//pages
import Index from '@/views/apps/reports/Index.vue'
import Reports from '@/views/apps/reports/Reports.vue'
import Kardex from '@/views/apps/reports/Kardex.vue'
import layouts from '@/layout'

export default {
	path: 'reports',
	name: 'Informes',
	component: Index,
	redirect: { path: '/inventory', name: 'inventory' },
	icon: 'briefcase',
	auth: true,
	meta: {
		nav: true,
		roles: ['admin', 'deposit', 'reports']
	},
	children: [
		{
			path: '/inventory',
			name: 'Inventario',
			component: Reports,
			meta: {
				nav: true,
				layout: layouts.navLeft,
				roles: ['admin', 'deposit', 'reports'],
				icon: 'cash-register',
			}
		},
		{
			path: '/kardex',
			name: 'Kardex',
			component: Kardex,
			meta: {
				nav: true,
				layout: layouts.navLeft,
				roles: ['admin', 'deposit'],
				icon: 'cash-register',
			}
		}
	]
}
